const Tooltip = {
  baseStyle: {
    fontSize: '13px',
    borderRadius: 'sm',
  },
}

export default Tooltip
